import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { authAPI } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem("fisio_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await authAPI.me();
      setUser(res.data.user);
      setTenant(res.data.tenant);
    } catch {
      localStorage.removeItem("fisio_token");
      localStorage.removeItem("fisio_user");
      localStorage.removeItem("fisio_tenant");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem("fisio_token", res.data.token);
    localStorage.setItem("fisio_user", JSON.stringify(res.data.user));
    localStorage.setItem("fisio_tenant", JSON.stringify(res.data.tenant));
    setUser(res.data.user);
    setTenant(res.data.tenant);
    return res.data;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    localStorage.setItem("fisio_token", res.data.token);
    localStorage.setItem("fisio_user", JSON.stringify(res.data.user));
    localStorage.setItem("fisio_tenant", JSON.stringify(res.data.tenant));
    setUser(res.data.user);
    setTenant(res.data.tenant);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("fisio_token");
    localStorage.removeItem("fisio_user");
    localStorage.removeItem("fisio_tenant");
    setUser(null);
    setTenant(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, loading, login, register, logout, loadUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
